import './Footer.css'
import { useTranslation } from 'react-i18next'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'

function Footer() {
  const { t } = useTranslation();
  return (
    <div className='flex justify-center items-center w-[100%]'>
      <div className='flex flex-col items-center w-[100%] h-auto bg-gradient-to-b from-brand-blue-900 to-[#040f2e] border-t border-brand-gold-300/40 text-center'>
        <div className='flex flex-col items-center w-[100%] px-4 md:px-20 xl:px-40 py-6 gap-3'>
          <span className='inline-flex items-center gap-1.5 rounded-pill border border-brand-gold-300/60 bg-white/5 px-3 py-1 text-brand-gold-300 font-heading text-[11px] font-bold tracking-wide'>
            <VerifiedUserIcon sx={{ fontSize: 14 }} />
            {t("footer.secureBadge")}
          </span>

          <span className='text-white/50 text-[12px] font-light font-body max-w-3xl'>
            {t("footer.description")}
          </span>

          <span className='text-white/60 text-[13px] font-bold font-body'>
            {t("footer.copyright")} - <span className='font-heading text-brand-gold-300'>MEESOK.COM</span> {t("footer.rightsReserved")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
